var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { APPLY_COLORS, breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
var cls = classNames('slice-jump-links');
export var SliceJumpLinksDefaultProps = {
  colors: {
    text: 'strong',
    hover: {
      text: 'primary'
    }
  }
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding: 0;\n    display: flex;\n    flex-wrap: nowrap;\n    margin: 0;\n    padding: 0;\n    font-size: 1em;\n    font-weight: 500;\n    text-transform: uppercase;\n\n    a {\n      white-space: nowrap;\n      text-decoration: none;\n      ", ";\n    }\n  "], ["\n    padding: 0;\n    display: flex;\n    flex-wrap: nowrap;\n    margin: 0;\n    padding: 0;\n    font-size: 1em;\n    font-weight: 500;\n    text-transform: uppercase;\n\n    a {\n      white-space: nowrap;\n      text-decoration: none;\n      ", ";\n    }\n  "])), APPLY_COLORS),
  tablet: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-size: ", "em;\n  "], ["\n    font-size: ", "em;\n  "])), 18 / 16),
  desktop: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-size: ", "em;\n  "], ["\n    font-size: ", "em;\n  "])), 20 / 17),
  desktopLarge: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), theme.V_DOT_BG())
});
var ItemStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    list-style: none;\n    flex-basis: 33.333%;\n    display: flex;\n    justify-content: center;\n    padding: ", " ", ";\n    ", ";\n\n    &:last-child {\n      background: none;\n    }\n  "], ["\n    list-style: none;\n    flex-basis: 33.333%;\n    display: flex;\n    justify-content: center;\n    padding: ", " ", ";\n    ", ";\n\n    &:last-child {\n      background: none;\n    }\n  "])), theme.UNIT(2), theme.UNIT(4), theme.V_DOT_BG_END()),
  tablet: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "]))),
  desktopLarge: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    &:last-child {\n      ", ";\n    }\n  "], ["\n    &:last-child {\n      ", ";\n    }\n  "])), theme.V_DOT_BG_END())
});
var LinkStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n\n  "], ["\n\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.ul(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Item: styled.li.attrs(cls.attr('item'))(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ItemStyles),
  Link: styled.a.attrs(cls.attr('link'))(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), LinkStyles)
};
export var SliceJumpLinks = function (props) {
  var className = props.className,
    colors = props.colors,
    _a = props.items,
    items = _a === void 0 ? [] : _a;
  if (!items.length) {
    return null;
  }
  return React.createElement(My.Container, {
    colors: colors,
    className: cls.name(className)
  }, items.map(function (item) {
    return React.createElement(My.Item, {
      key: item.id
    }, React.createElement(My.Link, {
      href: "#".concat(item.slug)
    }, item.title || item.name));
  }));
};
SliceJumpLinks.defaultProps = SliceJumpLinksDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;